import { Component, Input, OnInit } from '@angular/core';
import { UIRouter }                                      from '@uirouter/core';
import { TranslateService }                              from '@ngx-translate/core';

import { ApiService }      from '../../app-lite/api/api.service';
import { CustomerModel }  from '../../app-lite/customers/models/customer';
import { InvoiceModel }    from '../../app-lite/invoices/models/invoice';
import { Table }           from '../../app-lite/table/types/table';
import { TableColumn }     from '../../app-lite/table/types/table-column';
import { TableRowEvent }   from '../../app-lite/table/types/table-row-event';
import { TableService }    from '../../app-lite/table/table.service';

import { EditComponent }                 from '../../app-lite/table/cell-components/actions/edit.component';
import { InvoiceContactStatusComponent } from '../../app-lite/invoices/contact-status/invoice.contact-status.component';

@Component({
  selector   : 'customer-quotes',
  template: require('./customer.quotes.html')
})
export class CustomerQuotesComponent implements OnInit {
  @Input() customer: CustomerModel;
  @Input() quotes: InvoiceModel[];

  columns: TableColumn[];
  filtering: any = { begin_date: '', end_date: '', reference: '' };
  showCustomerQuotes: boolean;
  tableCacheKey: string;
  tableSettings: Table;

  constructor (
    private apiService: ApiService,
    private tableService: TableService,
    private router: UIRouter,
    private translateService: TranslateService
  ) {}

  ngOnInit () {
    this.showCustomerQuotes = !!this.quotes.length;
    this.tableCacheKey      = 'customerQuotes';

    this.filtering = this.tableService.setFiltersFromCache(this.tableCacheKey, {
      begin_date: '',
      end_date  : '',
      reference : ''
    });

    this.columns = [
      {
        field : 'job_card_number',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        field : 'post_date',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.QUOTE_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'cash_or_account',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.TYPE')
        },
        pipe: 'customerType'
      },
      {
        component: {
          enabled: true,
          factory: InvoiceContactStatusComponent
        },
        header: {
          classes: 'text-center',
          text   : this.translateService.instant('GENERAL_SPACE.STATUS.CONTACTED')
        },
        sortable: false
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : this.translateService.instant('GENERAL_SPACE.FIELD.QUOTE_AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: (event) => this.viewQuote(event)
            }
          },
          enabled: !this.customer.archived,
          factory: EditComponent },
        sortable: false }
    ];

    this.tableSettings = {
      broadcast: 'filterQuotes',
      cache    : {
        enabled: true,
        key    : this.tableCacheKey
      },
      columns: this.columns,
      empty  : {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_QUOTES_FOUND')
      },
      pagination: {
        enabled   : true,
        pageSize  : this.tableService.getCachedPaging(this.tableCacheKey).pageSize || 5,
        pageSizes : [ 5, 10, 25, 50 ],
        queryCount: () => this.apiService.get('/customers/quote_count_with_find/', [
          this.customer.id,
          this.filtering.begin_date || '*',
          this.filtering.end_date || '*',
          this.filtering.reference || '*'
        ])
      },
      rows: {
        highlight: {
          enabled: true
        }
      },
      sorting: this.tableService.setSortingFromCache(this.tableCacheKey, {
        direction: 'desc',
        field    : 'post_date'
      }) };
  }

  getQuotes ( params ): Promise<any> {
    return this.apiService.get('/customers/quote_list_with_find', [
      this.customer.id,
      params.offset,
      params.pageSize,
      this.filtering.begin_date || '*',
      this.filtering.end_date   || '*',
      params.field,
      params.direction,
      this.filtering.reference  || '*'
    ]).then((quotes) => {
      this.quotes = quotes;

      return quotes;
    });
  }

  onRowDoubleClick ( event: TableRowEvent ): void {
    if ( !this.customer.archived ) {

      this.viewQuote(event.row);

      };

    }

  viewQuote ( quote: InvoiceModel ): void {
    this.router.stateService.go('app.invoice', {
      customer_id: this.customer.id,
      id         : quote.id,
      vehicle_id : quote.vehicle_id
    });
  }

  filterQuotes (): void {


    window['filterQuotes'](this.filtering);


    };


  }
